import React, { useState } from 'react';
import { Header } from './components/Header';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ProtocolDetail } from './components/ProtocolDetail';
import { ProtocolList } from './components/ProtocolList';
import { Overview, Technique, AboutJin } from './components/StaticContent';
import { Protocol, PROTOCOLS } from './data/protocols';
type View = 'home' | 'protocols' | 'technique' | 'about' | 'protocol';
export function App() {
  const [currentView, setCurrentView] = useState<View>('home');
  const [selectedProtocol, setSelectedProtocol] = useState<Protocol | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const handleNavigate = (view: string) => {
    if (view === 'home' || view === 'protocols' || view === 'technique' || view === 'about') {
      setCurrentView(view as View);
      setSelectedProtocol(null);
    }
  };
  const handleSelectProtocol = (protocol: Protocol) => {
    setSelectedProtocol(protocol);
    setCurrentView('protocol');
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    if (query && currentView === 'home') {
      setCurrentView('protocols');
    }
  };
  const renderContent = () => {
    switch (currentView) {
      case 'home':
        return <Overview onNavigate={handleNavigate} data-id="element-0" />;
      case 'protocols':
        return <ProtocolList onSelectProtocol={handleSelectProtocol} searchQuery={searchQuery} data-id="element-1" />;
      case 'technique':
        return <Technique data-id="element-2" />;
      case 'about':
        return <AboutJin data-id="element-3" />;
      case 'protocol':
        return selectedProtocol ? <ProtocolDetail protocol={selectedProtocol} data-id="element-4" /> : <Overview onNavigate={handleNavigate} data-id="element-5" />;
      default:
        return <Overview onNavigate={handleNavigate} data-id="element-6" />;
    }
  };
  return <div className="min-h-screen bg-[#FAF8F6] flex flex-col font-sans text-[#1F1F1F]" data-id="element-7">
      <Header searchQuery={searchQuery} onSearchChange={handleSearch} data-id="element-8" />
      <Navigation currentView={currentView} onNavigate={handleNavigate} data-id="element-9" />

      <main className="flex-1" data-id="element-10">
        <div className="max-w-6xl mx-auto px-4 py-6" data-id="element-11">{renderContent()}</div>
      </main>

      <Footer data-id="element-12" />
    </div>;
}